import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from 'eventbrite_design_system/modal/Modal';

import transform from '../transform';
import defaultSettings from './settings.js';
import { SIGNUP_PAGE } from '../../constants/main';

import FeaturesComparison from '../../components/FeaturesComparison';
import './page.scss';

export default class SignUpPage extends PureComponent {
    static propTypes = {
        locale: PropTypes.string,
        isAuthenticated: PropTypes.bool,
    };

    render() {
        const {
            locale,
            isAuthenticated,
            feeBreakdown,
            assortmentsTax,
            selectedPackage,
            clearSelectedPackage,
            setSignupPackageOne,
            setSignupPackageTwo,
            setSignupPackageThree,
        } = this.props;
        const {
            packages,
            packageTypes,
            primaryHeading,
            secondaryHeading,
            featureDescriptions,
            paymentProcessingFeature,
            sections,
            CTAs,
            CTAStyles,
            extraMainFeatures,
            feeBreakdownOverride = {},
            finePrint,
            pricePerFreeTicket,
            shouldShowAnnualFee,
        } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            page: SIGNUP_PAGE,
        });

        const CTAActions = [
            setSignupPackageOne,
            setSignupPackageTwo,
            setSignupPackageThree,
        ];
        let finePrintText = null;

        const modalAnimOverrideClassName = {
            __className: 'marketing-modal--no-anim',
        };

        const formattedFeeBreakdown = _.merge(
            feeBreakdown,
            feeBreakdownOverride,
        );

        if (finePrint) {
            finePrintText = (
                <p className="eds-g-cell eds-g-cell-1-1 eds-text--center eds-text-bs eds-text-color--grey-600 eds-l-pad-bot-10">
                    {finePrint}
                </p>
            );
        }

        return (
            <div className="eds-g-cell">
                <Modal
                    type="complex"
                    isShown={true}
                    noPadding={true}
                    dangerouslySetContainerClassName={
                        modalAnimOverrideClassName
                    }
                    roleIsDialog={true}
                >
                    <FeaturesComparison
                        locale={locale}
                        packages={packages}
                        packageTypes={packageTypes}
                        feeBreakdown={formattedFeeBreakdown}
                        assortmentsTax={assortmentsTax}
                        primaryHeading={primaryHeading}
                        secondaryHeading={secondaryHeading}
                        featureDescriptions={featureDescriptions}
                        paymentProcessingFeature={paymentProcessingFeature}
                        sections={sections}
                        selectedPackage={selectedPackage}
                        getStartedActions={CTAActions}
                        clearSelectedPackage={clearSelectedPackage}
                        CTAs={CTAs}
                        CTAStyles={CTAStyles}
                        isSimplePricing={true}
                        extraMainFeatures={extraMainFeatures}
                        pricePerFreeTicket={pricePerFreeTicket}
                        shouldShowAnnualFee={shouldShowAnnualFee}
                    />
                    <div className="eds-bg-color--white">{finePrintText}</div>
                </Modal>
            </div>
        );
    }
}
